import { render, staticRenderFns } from "./UpdateRemark.vue?vue&type=template&id=3d7493a6&scoped=true"
import script from "./UpdateRemark.vue?vue&type=script&lang=js"
export * from "./UpdateRemark.vue?vue&type=script&lang=js"
import style0 from "./UpdateRemark.vue?vue&type=style&index=0&id=3d7493a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7493a6",
  null
  
)

export default component.exports